const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');
const SupplierWorkbench = () => import(/* webpackChunkName: "supplierManage" */'@/components/pages/supplierManage/Workbench');
const SupplierWorkflowOperate = () => import(/* webpackChunkName: "supplierManage" */'@/components/pages/supplierManage/SupplierWorkflowOperate');

export default [
  {
    path: '/supplier-manage',
    name: 'supplierManage',
    meta: {
      roles: ['SUPPLIER_QUERY']
    },
    component: Layout,
    children: [
      {
        path: 'supplier-bench',
        name: 'supplierBench',
        meta: {
          roles: ['SUPPLIER_QUERY'],
          title: '供应商管理',
          icon: 'customer-manage',
          activeMenu: '/supplier-manage/supplier-bench/',
          componentName: 'SupplierWorkbench',
          breadcrumb: [
            {
              name: '供应商管理',
              path: '/supplier-manage/supplier-bench'
            }
          ]
        },
        component: SupplierWorkbench
      },
      {
        path: 'edit-supplier-workflow/:id',
        props: true,
        name: 'editSupplierWorkflow',
        meta: {
          roles: ['SUPPLIER_UPDATE'],
          title: '编辑供应商',
          hidden: true,
          activeMenu: '/supplier-manage/supplier-bench',
          componentName: 'SupplierWorkflowOperate',
          breadcrumb: [
            {
              name: '供应商管理',
              path: '/supplier-manage/supplier-bench'
            },
            {
              name: '编辑供应商',
              path: '/supplier-manage/edit-supplier-workflow/:id'
            }
          ]
        },
        component: SupplierWorkflowOperate
      },
      {
        path: 'create-supplier-workflow',
        name: 'createSupplierWorkflow',
        meta: {
          roles: ['SUPPLIER_ADD'],
          title: '新建供应商',
          hidden: true,
          activeMenu: '/supplier-manage/supplier-bench',
          componentName: 'SupplierWorkflowOperate',
          breadcrumb: [
            {
              name: '供应商管理',
              path: '/supplier-manage/supplier-bench'
            },
            {
              name: '新建供应商',
              path: '/supplier-manage/create-supplier-workflow'
            }
          ]
        },
        component: SupplierWorkflowOperate
      },
      
    ]
  },
];



// WEBPACK FOOTER //
// ./src/router/supplierManage.js